import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import ImageUploader from "../../containers/ImageUploader/ImageUploader";

class PromoEdit extends Component {
	state = {
		data: "",
		fieldValues: {
			image: ""
		},
		bgFieldValues: {
			image: ""
		},
		deletedImage: false,
		deletedBackgroundImage: false,
		edit: false,
		modal: false
	};

	componentDidMount() {
		this.state = {
			data: this.props.info,
			modal: false,
			edit: false,
			deletedImage: false,
			deletedBackgroundImage: false
		};

		this.setState({
			titulo: this.props.title,
			descripcion: this.props.info,
			image: this.props.imagen,
			descuento: this.props.descuento,
			backgroundImage: this.props.imagenfondo,
			id: this.props.id
		})
	}

	handleConfirm = () => {
		this.props.handleDelete({ id: this.props.id }, this.props.token);
	};

	handleEdit = () => {
		if(this.state.deletedImage == true && this.state.deletedBackgroundImage == true) {
			this.props.handleSaveEdit(
				{
					titulo: this.state.titulo,
					descripcion: this.state.descripcion,
					image: this.state.fieldValues.image,
					backgroundImage: this.state.bgFieldValues.image,
					descuento: this.state.descuento,
					id: this.props.id
				},
				this.props.token
			);
			this.setState({
				modal: false,
				edit: false,
				deletedImage: false
			});
		}else if(this.state.deletedImage == true && this.state.deletedBackgroundImage == false) {
			console.log(this.state.fieldValues.image);

			this.props.handleSaveEditOnlyImage(
				{
					titulo: this.state.titulo,
					descripcion: this.state.descripcion,
					image: this.state.fieldValues.image,
					descuento: this.state.descuento,
					id: this.props.id
				},
				this.props.token
			);
			this.setState({
				modal: false,
				edit: false,
				deletedImage: false
			});
		}else if(this.state.deletedImage == false && this.state.deletedBackgroundImage == true) {
			this.props.handleSaveEditOnlyBackground(
				{
					titulo: this.state.titulo,
					descripcion: this.state.descripcion,
					backgroundImage: this.state.bgFieldValues.image,
					descuento: this.state.descuento,
					id: this.props.id
				},
				this.props.token
			);
			this.setState({
				modal: false,
				edit: false,
				deletedImage: false
			});
		}else if(this.state.deletedImage == false && this.state.deletedBackgroundImage == false) {
			this.props.handleSaveEditNoImage(
				{
					titulo: this.state.titulo,
					descripcion: this.state.descripcion,
					descuento: this.state.descuento,
					id: this.props.id
				},
				this.props.token
			);
			this.setState({
				modal: false,
				edit: false,
				deletedImage: false
			});
		}
	};

	handleCancel = () => {
		this.setState({
			modal: false
		});
	};

	handleCancelEdit = () => {
		this.setState({
			edit: false
		});
	};

	openModal = () => {
		console.log("OPENM MODAL");
		this.setState({
			modal: true
		});
	};

	openEdit = () => {
		console.log("OPENM EDIT");
		this.setState({
			edit: true
		});
	};

	deleteImage = () => {
		console.log("DELETE IMAGE");
		this.setState({
			deletedImage: true
		});
	};

	deleteBackgroundImage = () => {
		console.log("DELETE BACKGROUND IMAGE");
		this.setState({
			deletedBackgroundImage: true
		});
	};

	render() {
		return (
			<React.Fragment>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.modal}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea Borrar la promoción?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancel}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.edit}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea sobreescribir la promoción con estos cambios?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleEdit}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancelEdit}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Card style={{ width: "100%", marginBottom: 10 }}>
					<CardContent>
						<TextField
							id="outlined-basic"
							label="Titulo"
							variant="outlined"
							defaultValue={this.props.title}
							onChange={value => this.setState({ titulo: value.target.value })}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
							id="outlined-basic"
							label="Descripción"
							variant="outlined"
							multiline
							defaultValue={this.props.info}
							onChange={value => this.setState({ descripcion: value.target.value })}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
							id="outlined-basic"
							label="Descuento"
							variant="outlined"
							multiline
							defaultValue={this.props.descuento}
							onChange={value => this.setState({ descuento: value.target.value })}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						Imagen
						<br />
						<br />
						{
								this.state.deletedImage == true ? 
								<ImageUploader fieldValues={this.state.fieldValues} />
								: 
								<CardMedia
								image={this.props.imagen}
								title="Imagen"
								style={{ width: "200px", height: "200px", marginLeft: "5%" }}
							/>}

						<br />
						<br />	
						{
								this.state.deletedImage == true ? 
								null
								: 
								<Button
								color="secondary"
								onClick={() => {
								this.deleteImage();
								}}>
									Borrar Imagen
								</Button>
						}
						<br />
						<br />
						Imagen de fondo
						<br />
						<br />	
						{
								this.state.deletedBackgroundImage == true ? 
								<ImageUploader fieldValues={this.state.bgFieldValues} />
								: 
								<CardMedia
								image={this.props.imagenfondo}
								title="Imagen"
								style={{ width: "200px", height: "200px", marginLeft: "5%" }}
							/>}

						<br />
						<br />	
						{
								this.state.deletedBackgroundImage == true ? 
								null
								: 
								<Button
								color="secondary"
								onClick={() => {
								this.deleteBackgroundImage();
								}}>
									Borrar Imagen de Fondo
								</Button>
						}
						<br />
						<br />	
					</CardContent>

					<CardActions>
						<Button
							color="secondary"
							onClick={() => {
								this.openEdit();
							}}
						>
							Guardar Cambios
						</Button>
						<Button
							color="secondary"
							onClick={() => {
								this.openModal();
							}}
						>
							Borrar
						</Button>
					</CardActions>
				</Card>
			</React.Fragment>
		);
	}
}
export default PromoEdit;
